export const replaceArrow = (value: string): string => {
  return value.split('->').join('→')
}
